import styled from 'styled-components';

import { Modal } from 'react-bootstrap';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const BasesWrapper = styled.div``;

export const SelectBasesWrap = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const BasesContainer = styled.div`
  max-height: 500px;
  overflow-y: auto;
  padding: 0 8px 0 0;
  gap: 12px;
  display: flex;
  flex-direction: column;

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: #e9e9e9;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #0b29fb;
    border-radius: 6px;
    border: 2px solid #e9e9e9;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #0b29fb;
    border-radius: 6px;
  }
`;

export const RefuelFormWrap = styled.div`
  width: 68%;
  padding: 0 16px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const HeaderCard = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardTitle = styled.span`
  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #3d3d3d;

  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 18px;
  }
`;

export const CardSubTitle = styled.span`
  margin-top: 8px;
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;

  @media (max-width: 768px) {
    font-size: 10px;
    line-height: 15px;
  }
`;

export const FuelLevelWrapper = styled.div`
  margin-top: 16px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  width: 100%;
`;

export const FuelCardHeader = styled.div`
  padding: 18px 28px;
  background: #eeeeee;
  margin: 4px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalInfoButton = styled.div`
  padding: 8px 10px;
  border: 1px solid #0b29fb;
  border-radius: 8px;
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  color: #0b29fb;
  cursor: pointer;
  background: #ffff;

  @media (max-width: 768px) {
    font-size: 10px;
    line-height: 20px;
  }
`;

export const CardFuelWrapper = styled.div`
  height: 330px;
  padding: 0 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
    padding: 0 12px;
    gap: 52px;
    height: 500px;
  }
`;

export const GasImg = styled.img`
  margin-bottom: -46px;
`;

export const ModalStyled = styled(Modal)`
  & .modal-dialog {
    max-width: 550px;
    width: 100%;
  }

  & .modal-content {
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    padding: 25px 40px;
    width: 100%;

    @media (max-width: 768px) {
      padding: 25px;
    }
  }
`;

export const Content = styled.div`
  position: relative;
`;
